export default {"src":"/_next/static/media/nl.85512516.svg","height":480,"width":640};